export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-3bd24b0deb9026b4ef6901634b5422f6.woff";